import React from 'react';
import styles from './ServiceSelection.module.scss';
import { ChipsGroup } from 'app/components';
import {
  useAppSelector,
  useAppDispatch,
  setService,
  getBootstrapApp,
  getService,
  setCurrentFile,
  setInputSize
} from 'app/redux';
import { smoothScrollingToAnchor } from 'app/utils';

export const ServiceSelection: React.FC = () => {
  const dispatch = useAppDispatch();
  const bootstrap = useAppSelector(getBootstrapApp);
  const currentService = useAppSelector(getService);
  const services = bootstrap.services;

  const handleServiceSelection = ({
    status,
    value
  }: {
    status: boolean;
    value: string;
  }): void => {
    dispatch(setService(value));
    dispatch(setCurrentFile(undefined));
    dispatch(setInputSize(undefined));
    if (currentService === value && !status) {
      dispatch(setService(undefined));
    }
    if (status) smoothScrollingToAnchor('upload-document');
  };

  return (
    <>
      <div className={styles.services} id="services">
        <h3 className={styles['heading-3']}>2. Choose your service</h3>

        <div className={styles.chips}>
          {
            <ChipsGroup
              chipElements={services}
              selected={currentService}
              serviceMode
              onClick={handleServiceSelection}
            />
          }
        </div>
      </div>
    </>
  );
};
